import React, { useEffect } from "react";
import "./PaymentStatus.scss";

import { LuLoader } from "react-icons/lu";
import { AiOutlineReload } from "react-icons/ai";
import { IoReceiptOutline } from "react-icons/io5";

import CustomButton from "../../../components/CustomButton/CustomButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearCart } from "../../../redux/features/cart-slice";
import ROUTES from "../../../constants/routes";

const PaymentStatus = ({
  status,
  currency,
  totalPrice,
  submitting,
  handleRetry,
  saleID,
  remainingAmount,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleStartNewSale = (pdf) => {
    dispatch(clearCart());
    if (!pdf) {
      navigate(ROUTES.checkout.path);
    }
  };

  useEffect(() => {
    return () => {
      if (status === "success") {
        dispatch(clearCart());
      }
    };
  }, [dispatch, status]);
  return (
    <div className="payment-status container-wrapper">
      <div className={`message-container ${status}`}>
        {submitting ? (
          <LuLoader className="loading" />
        ) : (
          <>
            <img
              src={
                status === "success"
                  ? "/images/paymentSuccess.svg"
                  : "/images/paymentFailed.svg"
              }
              alt="" aria-label={status === "success" ? "Payment Success Status" : "Payment Failed Status"}
            />
            <p className={`title ${status}`}>
              Payment {status === "success" ? "Successful" : "Failed"}
            </p>
            {status === "failed" && (
              <p className="message">
                Something went wrong we couldn't process your payment. Contact
                our support if you have lost money.
              </p>
            )}
            {status === "success" && (
              <p className="price">
                {currency}{totalPrice} <br />
              </p>
            )}

            {status === "success" && Number(remainingAmount) < 0 && (
              <p className="change">
                Change:{" "}
                <span>
                  {currency}{Number(remainingAmount) * -1}
                </span>
              </p>
            )}

            {status === "failed" && (
              <button
                className="retry-button"
                type="button"
                onClick={handleRetry}
              >
                <AiOutlineReload />
                Retry
              </button>
            )}

            <div className="desktop-button">
              <CustomButton
                name={status === "success" ? "Start a new sale" : "Support"}
                type={"button"}
                color={status === "success" ? "primary" : "danger"}
                bigButton={true}
                handleSubmit={() => {
                  if (status === "success") {
                    handleStartNewSale();
                  } else {
                    navigate(ROUTES.help.path);
                  }
                }}
              />
            </div>
          </>
        )}
      </div>

      {status === "failed" && (
        <div className="floating-button">
          <CustomButton
            name={"Support"}
            type={"button"}
            color={"primary inline"}
            bigButton={true}
            handleSubmit={() => {}}
          />
        </div>
      )}

      {status === "success" && (
        <div className="floating-button">
          {saleID !== "offline" && (
            <div
              className="print"
              onClick={() => {
                navigate(ROUTES.salesPdf.path, { state: { saleId: saleID } });
                handleStartNewSale(true);
              }}
            >
              <IoReceiptOutline />
            </div>
          )}
          <CustomButton
            name={"Start a new sale"}
            type={"button"}
            color={"primary"}
            bigButton={true}
            handleSubmit={handleStartNewSale}
          />
        </div>
      )}
    </div>
  );
};

export default PaymentStatus;
